import {
  DashboardOutlined,
  DollarOutlined,
  FileImageOutlined,
  GlobalOutlined,
  HomeOutlined,
  InboxOutlined,
  LineChartOutlined,
  SearchOutlined,
  SendOutlined,
  SwitcherOutlined,
  ToolOutlined,
  ProfileOutlined,
  CloseCircleOutlined,
  GoldOutlined,
  CreditCardOutlined,
  TableOutlined,
  ApiOutlined,
  ClockCircleOutlined,
  DeliveredProcedureOutlined,
  UsergroupAddOutlined,
  AlertOutlined,
  UserOutlined,
  MessageOutlined,
  ShopOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "home",
    path: `${APP_PREFIX_PATH}`,
    title: "home",
    icon: HomeOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "analytics",
    path: `${APP_PREFIX_PATH}/analytics`,
    title: "analytics",
    icon: DollarOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "ccu",
        path: `${APP_PREFIX_PATH}/analytics/ccu`,
        title: "sidenav.analytics.ccu",
        icon: LineChartOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "revenue",
        path: `${APP_PREFIX_PATH}/analytics/revenue`,
        title: "sidenav.analytics.revenue",
        icon: LineChartOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "new-players-revenue",
        path: `${APP_PREFIX_PATH}/analytics/new-players-revenue`,
        title: "sidenav.analytics.new-players-revenue",
        icon: LineChartOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "gateway-info",
        path: `${APP_PREFIX_PATH}/analytics/gateway-info`,
        title: "sidenav.analytics.gateway-info",
        icon: DollarOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "crm",
        path: `${APP_PREFIX_PATH}/analytics/crm`,
        title: "sidenav.analytics.crm",
        icon: GlobalOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "item-amount",
        path: `${APP_PREFIX_PATH}/analytics/item-amount`,
        title: "sidenav.analytics.item-amount",
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "performance",
        path: `${APP_PREFIX_PATH}/analytics/performance`,
        title: "sidenav.analytics.performance",
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "urlshorter-metrics",
        path: `${APP_PREFIX_PATH}/analytics/urlshorter-metrics`,
        title: "sidenav.analytics.urlshorter-metrics",
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "royalarena-reports",
        path: `${APP_PREFIX_PATH}/analytics/royalarena-reports`,
        title: "sidenav.analytics.royalarena-reports",
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [],
      },

      {
        key: "activeplayers-per-country",
        path: `${APP_PREFIX_PATH}/analytics/activeplayers-per-country`,
        title: "sidenav.analytics.activeplayers-per-country",
        icon: GlobalOutlined,
        breadcrumb: false,
        submenu: [],
      },
      /* comment: Página desativada temporariamente */
      /*    
         {
              key: "sunset-followup",
              path: `${APP_PREFIX_PATH}/analytics/sunset-followup`,
              title: "sidenav.analytics.sunset-followup",
              icon: ProfileOutlined,
              breadcrumb: false,
              submenu: [],
          }, 
      */
      {
        key: "generate-player-purchase-report",
        path: `${APP_PREFIX_PATH}/analytics/generate-player-purchase-report`,
        title: "sidenav.analytics.generate-player-purchase-report",
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "graylist",
        path: `${APP_PREFIX_PATH}/analytics/graylist`,
        title: "sidenav.analytics.graylist",
        icon: AlertOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "campaign-cost",
        path: `${APP_PREFIX_PATH}/analytics/campaign-cost`,
        title: "sidenav.analytics.campaign-cost",
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "personas",
        path: `${APP_PREFIX_PATH}/analytics/personas`,
        title: "sidenav.analytics.personas",
        icon: UserOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "revenue-goals",
        path: `${APP_PREFIX_PATH}/analytics/revenue-goals`,
        title: "sidenav.analytics.revenue-goals",
        icon: DollarOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  {
    key: "operation",
    path: `${APP_PREFIX_PATH}/operation`,
    title: "operation",
    icon: FileImageOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "upload-banner",
        path: `${APP_PREFIX_PATH}/operation/upload-banner`,
        title: "sidenav.operation.upload-banner",
        icon: FileImageOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "modify-home-buttons",
        path: `${APP_PREFIX_PATH}/operation/modify-home-buttons`,
        title: "sidenav.operation.modify-home-buttons",
        icon: FileImageOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "manage-patch",
        path: `${APP_PREFIX_PATH}/operation/manage-patch`,
        title: "sidenav.operation.manage-patch",
        icon: SwitcherOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "schedule-downtime",
        path: `${APP_PREFIX_PATH}/operation/schedule-downtime`,
        title: "sidenav.operation.schedule-downtime",
        icon: ClockCircleOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "clone-accounts",
        path: `${APP_PREFIX_PATH}/operation/clone-accounts`,
        title: "sidenav.operation.clone-accounts",
        icon: DeliveredProcedureOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "cash-store",
        path: `${APP_PREFIX_PATH}/operation/cash-store`,
        title: "sidenav.operation.cash-store",
        icon: GoldOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "auto-ban",
        path: `${APP_PREFIX_PATH}/operation/auto-ban`,
        title: "sidenav.operation.auto-ban",
        icon: ToolOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "client-files-manager",
        path: `${APP_PREFIX_PATH}/operation/client-files-manager`,
        title: "sidenav.operation.client-files-manager",
        icon: FileImageOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "loyalty-path",
        path: `${APP_PREFIX_PATH}/operation/loyalty-path`,
        title: "sidenav.operation.loyalty-path",
        icon: ShopOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "drop-list-exceptions",
        path: `${APP_PREFIX_PATH}/operation/drop-list-exceptions`,
        title: "sidenav.operation.drop-list-exceptions",
        icon: ToolOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "inventario-virtual",
        path: `${APP_PREFIX_PATH}/operation/inventario-virtual`,
        title: "Inventário Virtual",
        icon: InboxOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "loki-audit",
        path: `${APP_PREFIX_PATH}/operation/loki-audit`,
        title: "Loki Audit",
        icon: ThunderboltOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  {
    key: "support",
    path: `${APP_PREFIX_PATH}/support`,
    title: "support",
    icon: DashboardOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "find-player",
        path: `${APP_PREFIX_PATH}/support/find-player`,
        title: "sidenav.support.findplayer",
        icon: SearchOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "find-guild",
        path: `${APP_PREFIX_PATH}/support/find-guild`,
        title: "sidenav.support.findguild",
        icon: SearchOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "rank-players",
        path: `${APP_PREFIX_PATH}/support/rank-players`,
        title: "sidenav.support.rankPlayers",
        icon: TableOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "rank-guilds",
        path: `${APP_PREFIX_PATH}/support/rank-guilds`,
        title: "sidenav.support.rankGuilds",
        icon: TableOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "twitch-users",
        path: `${APP_PREFIX_PATH}/support/twitch-users`,
        title: "sidenav.operation.twitch-users",
        icon: SearchOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "send-items",
        path: `${APP_PREFIX_PATH}/support/send-items`,
        title: "sidenav.support.sendItems",
        icon: SendOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "ban-players",
        path: `${APP_PREFIX_PATH}/support/ban-players`,
        title: "sidenav.support.banPlayers",
        icon: CloseCircleOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "gm-tools",
        path: `${APP_PREFIX_PATH}/support/gm-tools`,
        title: "sidenav.support.gmTools",
        icon: ToolOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "gold-count",
        path: `${APP_PREFIX_PATH}/support/gold-count`,
        title: "sidenav.support.goldCount",
        icon: GoldOutlined,
        breadcrumb: false,
        submenu: [],
      },

      {
        key: "accounts-np",
        path: `${APP_PREFIX_PATH}/support/accounts-np`,
        title: "sidenav.support.accountsNp",
        icon: CreditCardOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "global-bot",
        path: `${APP_PREFIX_PATH}/support/global-bot`,
        title: "sidenav.support.globalBot",
        icon: ToolOutlined,
        breadcrumb: false,
        submenu: [],
      },
      // {
      //   key: "global-bot-tool",
      //   path: `${APP_PREFIX_PATH}/support/global-bot-tool`,
      //   title: "sidenav.support.globalBotTool",
      //   icon: ToolOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      // },
      {
        key: "editor-info-json",
        path: `${APP_PREFIX_PATH}/support/editor-info-json`,
        title: "sidebar.support.editorInfoJson",
        icon: ToolOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "all-emails",
        path: `${APP_PREFIX_PATH}/support/all-emails`,
        title: "sidebar.support.allEmails",
        icon: ToolOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "action-logs",
        path: `${APP_PREFIX_PATH}/support/action-logs`,
        title: "sidenav.support.actionLogs",
        icon: ToolOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "log-analyzer",
        path: `${APP_PREFIX_PATH}/support/log-analyzer`,
        title: "sidenav.support.logAnalyzer",
        icon: SearchOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "item-tracking",
        path: `${APP_PREFIX_PATH}/support/item-tracking`,
        title: "sidenav.support.itemTracking",
        icon: SearchOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "purchase-management",
        path: `${APP_PREFIX_PATH}/support/purchase-management`,
        title: "sidenav.support.purchaseManagement",
        icon: TableOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "related-accounts",
        path: `${APP_PREFIX_PATH}/support/related-accounts`,
        title: "Contas Relacionadas",
        icon: UsergroupAddOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "send-custom-email",
        path: `${APP_PREFIX_PATH}/support/send-custom-email`,
        title: "sidenav.support.sendCustomEmail",
        icon: TableOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "punishment-list",
        path: `${APP_PREFIX_PATH}/support/punishment-list`,
        title: "sidenav.support.punishmentlist",
        icon: TableOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "incidents-tickets",
        path: `${APP_PREFIX_PATH}/support/incidents-tickets`,
        title: "sidenav.support.incidents-tickets",
        icon: AlertOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "search-key-items",
        path: `${APP_PREFIX_PATH}/support/search-key-items`,
        title: "sidenav.support.searchKeyItems",
        icon: SearchOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "costume-identifier",
        path: `${APP_PREFIX_PATH}/support/costume-identifier`,
        title: "sidenav.support.costumeIdentifier",
        icon: SearchOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "game-metrics",
        path: `${APP_PREFIX_PATH}/support/game-metrics`,
        title: "sidenav.support.gameMetrics",
        icon: LineChartOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  {
    key: "developer",
    path: `${APP_PREFIX_PATH}/developer`,
    title: "development",
    icon: FileImageOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "manage-rds",
        path: `${APP_PREFIX_PATH}/developer/manage-rds`,
        title: "sidenav.developer.manageRds",
        icon: ApiOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "manage-users",
        path: `${APP_PREFIX_PATH}/developer/manage-users`,
        title: "sidenav.developer.manageUsers",
        icon: ApiOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
